/* assets/armonia-cart.js
   Pagina carrello Armonia: <armonia-cart>.
   - quantità +/− e campo numerico (con piccolo ritardo, poi una sola chiamata a /cart/change.js)
   - Rimuovi, "Sposta nei preferiti" (lista in localStorage 'armonia:favorites', come le card)
   - dopo ogni modifica chiede a Shopify la stessa sezione (Section Rendering API) e sostituisce
     [data-armonia-cart-root]; aggiorna anche il contatore nell'header (#cart-icon-bubble)
   - codice sconto: viene passato al check-out dal campo name="discount" del form (DA VERIFICARE sul negozio)
   - consegna stimata (stesse regole della scheda prodotto: lun–ven, cutoff, fuso, sabato sì / domenica no)
   - barra check-out mobile: si nasconde quando il bottone principale o il footer sono in vista
   Non usa il cart.js di Dawn: sulla pagina carrello il drawer non viene caricato. */
(function () {
  'use strict';

  var A = (window.Armonia = window.Armonia || {});

  function cfg() { return A.config || {}; }
  function track(name, params) { if (A.track) A.track(name, params); }
  function fmt(str, vars) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return vars && vars[k] !== undefined ? vars[k] : m; });
  }
  function routesUrl(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  /* ---------- Consegna stimata (stessa logica di armonia-product.js) ---------- */
  function romeNow(tz) {
    var d = new Date();
    var parts = {};
    try {
      new Intl.DateTimeFormat('en-GB', {
        timeZone: tz, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23'
      }).formatToParts(d).forEach(function (p) { parts[p.type] = parseInt(p.value, 10); });
    } catch (e) {
      parts = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate(), hour: d.getHours() };
    }
    return { date: new Date(Date.UTC(parts.year, parts.month - 1, parts.day, 12)), hour: (parts.hour || 0) % 24 };
  }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }
  function isBiz(d) { var w = d.getUTCDay(); return w >= 1 && w <= 5; }
  function addDeliveryDays(d, n, saturday) {
    var x = new Date(d.getTime());
    while (n > 0) {
      x = addDays(x, 1);
      var w = x.getUTCDay();
      if (w === 0 || (w === 6 && !saturday)) continue;
      n -= 1;
    }
    return x;
  }
  function computeDelivery() {
    var c = cfg();
    var tz = c.timezone || 'Europe/Rome';
    var cutoff = typeof c.cutoffHour === 'number' ? c.cutoffHour : 17;
    var minD = c.deliveryMinDays || 1;
    var maxD = Math.max(c.deliveryMaxDays || 2, minD);
    var sat = c.saturdayDelivery !== false;
    var now = romeNow(tz);
    var shipToday = isBiz(now.date) && now.hour < cutoff;
    var ship = now.date;
    if (!shipToday) {
      ship = addDays(now.date, 1);
      while (!isBiz(ship)) ship = addDays(ship, 1);
    }
    return {
      today: shipToday,
      ship: ship,
      tomorrow: !shipToday && ship.getTime() - now.date.getTime() === 86400000,
      from: addDeliveryDays(ship, minD, sat),
      to: addDeliveryDays(ship, maxD, sat),
      cutoff: cutoff,
      locale: c.locale || 'it-IT'
    };
  }
  function fmtDay(d, locale, opts) {
    var o = opts || { weekday: 'short', day: 'numeric', month: 'short' };
    o.timeZone = 'UTC';
    try { return d.toLocaleDateString(locale, o).replace(/\./g, ''); } catch (e) { return d.toISOString().slice(0, 10); }
  }

  class ArmoniaCart extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.sectionId = this.dataset.sectionId;
      var sj = this.querySelector('[data-armonia-cart-strings]');
      try { this.S = JSON.parse(sj ? sj.textContent : '{}'); } catch (e) { this.S = {}; }
      this.live = this.querySelector('[data-armonia-cart-live]');

      this.queue = {};      /* key riga -> quantità desiderata */
      this.timer = null;
      this.busy = false;
      this.again = false;
      this.info = null;     /* {kind:'removed'|'moved', title} per il messaggio finale */
      this.codeState = { value: '', open: false, ready: false };
      this.observers = [];

      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onPageShow = this.onPageShow.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.addEventListener('keydown', this.onKeydown);
      window.addEventListener('pageshow', this.onPageShow);

      this.watchHeader();
      this.afterRender(true);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('pageshow', this.onPageShow);
      this.disconnectObservers();
      if (this.headerObserver) this.headerObserver.disconnect();
    }

    get root() { return this.querySelector('[data-armonia-cart-root]'); }

    onPageShow(e) {
      /* tornando indietro dal check-out il carrello può essere cambiato */
      if (e.persisted) this.refresh();
    }

    /* ---------- Altezza header (per il riepilogo sticky) ---------- */
    watchHeader() {
      var header = document.querySelector('.armonia-header');
      if (!header) return;
      var set = function () {
        var h = header.getBoundingClientRect().height;
        if (h > 0) document.documentElement.style.setProperty('--armonia-header-h', h / 10 + 'rem');
      };
      set();
      window.addEventListener('resize', set);
      if ('ResizeObserver' in window) {
        this.headerObserver = new ResizeObserver(set);
        this.headerObserver.observe(header);
      }
    }

    disconnectObservers() {
      this.observers.forEach(function (o) { o.disconnect(); });
      this.observers = [];
    }

    /* ---------- Dopo ogni disegno del carrello ---------- */
    afterRender(first) {
      var root = this.root;
      if (!root) return;
      this.disconnectObservers();
      this.initDelivery();
      this.initExpress();
      this.initSticky();
      this.restoreCode();
      if (first && root.dataset.empty !== 'true') {
        track('view_cart', { ecommerce: this.ecommerce() });
      }
    }

    /* Elenco articoli nel formato GA4 (lo sistema meglio la fase Tracking) */
    ecommerce() {
      var root = this.root;
      var items = [];
      root.querySelectorAll('[data-armonia-line]').forEach(function (li) {
        items.push({
          item_id: li.dataset.variantId,
          item_name: li.dataset.title,
          item_brand: li.dataset.brand,
          price: (parseInt(li.dataset.price, 10) || 0) / 100,
          quantity: parseInt(li.dataset.qty, 10) || 1
        });
      });
      return { currency: this.dataset.currency, value: (parseInt(root.dataset.total, 10) || 0) / 100, items: items };
    }

    /* ---------- Consegna ---------- */
    initDelivery() {
      var box = this.root.querySelector('[data-armonia-delivery]');
      if (!box) return;
      var S = this.S;
      var d = computeDelivery();
      var title = box.querySelector('[data-armonia-delivery-title]');
      var note = box.querySelector('[data-armonia-delivery-note]');
      var range = d.from.getTime() === d.to.getTime()
        ? fmtDay(d.from, d.locale)
        : fmtDay(d.from, d.locale) + ' e ' + fmtDay(d.to, d.locale);
      var lead = d.today
        ? fmt(S.deliveryToday, { hour: d.cutoff })
        : fmt(S.deliveryShip, { day: d.tomorrow ? S.deliveryTomorrow : fmtDay(d.ship, d.locale, { weekday: 'long' }) });
      if (title) title.textContent = fmt(S.deliveryTitle, { range: range });
      if (note) note.textContent = lead + (S.deliveryTail ? ' · ' + S.deliveryTail : '');
    }

    /* ---------- Express checkout: l'etichetta compare solo se i bottoni ci sono ---------- */
    initExpress() {
      var ex = this.root.querySelector('[data-armonia-express]');
      if (!ex) return;
      var box = ex.querySelector('.armonia-cart-express__buttons');
      if (!box) return;
      var check = function () { ex.classList.toggle('is-empty', box.offsetHeight < 10); };
      check();
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(check);
        ro.observe(box);
        this.observers.push(ro);
      }
    }

    /* ---------- Barra check-out mobile ---------- */
    initSticky() {
      var root = this.root;
      var bar = root.querySelector('[data-armonia-cart-sticky]');
      var btn = root.querySelector('.armonia-cart-summary__checkout');
      if (!bar || !btn || !('IntersectionObserver' in window)) return;
      var btnIn = false;
      var footerIn = false;
      function paint() { bar.classList.toggle('is-hidden', btnIn || footerIn); }
      var o1 = new IntersectionObserver(function (entries) {
        btnIn = entries[entries.length - 1].isIntersecting;
        paint();
      });
      o1.observe(btn);
      this.observers.push(o1);
      var footer = document.querySelector('footer');
      if (footer) {
        var o2 = new IntersectionObserver(function (entries) {
          footerIn = entries[entries.length - 1].isIntersecting;
          paint();
        });
        o2.observe(footer);
        this.observers.push(o2);
      }
    }

    /* ---------- Eventi ---------- */
    onClick(event) {
      var t = event.target;
      if (!t.closest) return;

      var qtyBtn = t.closest('[data-armonia-qty]');
      if (qtyBtn) {
        var li = qtyBtn.closest('[data-armonia-line]');
        var input = li && li.querySelector('[data-armonia-qty-input]');
        if (!input) return;
        var step = parseInt(input.step, 10) || 1;
        var delta = parseInt(qtyBtn.getAttribute('data-armonia-qty'), 10) || 0;
        this.setQty(li, (parseInt(input.value, 10) || 0) + delta * step);
        return;
      }

      var rm = t.closest('[data-armonia-remove]');
      if (rm) {
        var rl = rm.closest('[data-armonia-line]');
        if (!rl) return;
        track('remove_from_cart', { ecommerce: this.lineEcommerce(rl) });
        this.info = { kind: 'removed', title: rl.dataset.title };
        this.setQty(rl, 0, true);
        return;
      }

      var fav = t.closest('[data-armonia-fav-move]');
      if (fav) {
        var fl = fav.closest('[data-armonia-line]');
        if (!fl) return;
        this.moveToFavorites(fl);
        return;
      }

      if (t.closest('[data-armonia-code-apply]')) { this.applyCode(); return; }
      if (t.closest('[data-armonia-code-clear]')) { this.clearCode(); return; }

      var co = t.closest('[data-armonia-checkout]');
      if (co) {
        /* se ci sono modifiche in attesa, prima le salviamo, poi si va al check-out */
        if (this.timer || this.busy || Object.keys(this.queue).length) {
          event.preventDefault();
          var self = this;
          this.afterFlush = function () {
            var b = self.root.querySelector('.armonia-cart-summary__checkout');
            if (b) b.click();
          };
          this.flush(true);
          return;
        }
        track('begin_checkout', { ecommerce: this.ecommerce() });
      }
    }

    onChange(event) {
      var input = event.target.closest && event.target.closest('[data-armonia-qty-input]');
      if (!input) return;
      var li = input.closest('[data-armonia-line]');
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 0) {
        input.value = li.dataset.qty;
        return;
      }
      this.setQty(li, v);
    }

    onKeydown(event) {
      if (event.key !== 'Enter') return;
      var t = event.target;
      if (t.matches && t.matches('[data-armonia-code]')) {
        event.preventDefault();
        this.applyCode();
      } else if (t.matches && t.matches('[data-armonia-qty-input]')) {
        event.preventDefault();
        t.blur();
      }
    }

    lineEcommerce(li) {
      return {
        currency: this.dataset.currency,
        value: ((parseInt(li.dataset.price, 10) || 0) * (parseInt(li.dataset.qty, 10) || 1)) / 100,
        items: [{
          item_id: li.dataset.variantId,
          item_name: li.dataset.title,
          item_brand: li.dataset.brand,
          price: (parseInt(li.dataset.price, 10) || 0) / 100,
          quantity: parseInt(li.dataset.qty, 10) || 1
        }]
      };
    }

    /* ---------- Quantità ---------- */
    setQty(li, qty, immediate) {
      var input = li.querySelector('[data-armonia-qty-input]');
      var max = input && input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : Infinity;
      qty = Math.max(0, qty);
      if (qty > max) qty = max;
      if (input) input.value = qty;
      var err = li.querySelector('[data-armonia-line-error]');
      if (err) err.textContent = '';
      if (qty === (parseInt(li.dataset.qty, 10) || 0) && !(li.dataset.key in this.queue)) return;
      this.queue[li.dataset.key] = qty;
      if (qty === 0) li.classList.add('is-removing');
      this.classList.add('is-loading');
      clearTimeout(this.timer);
      var self = this;
      this.timer = setTimeout(function () { self.timer = null; self.flush(); }, immediate || qty === 0 ? 0 : 350);
    }

    flush(force) {
      clearTimeout(this.timer);
      this.timer = null;
      if (this.busy) { this.again = true; return; }
      var keys = Object.keys(this.queue);
      if (!keys.length) {
        if (force && this.afterFlush) { var f0 = this.afterFlush; this.afterFlush = null; f0(); }
        return;
      }
      var jobs = keys.map(function (k) { return { key: k, qty: this.queue[k] }; }, this);
      this.queue = {};
      this.busy = true;
      var root = this.root;
      if (root) root.setAttribute('aria-busy', 'true');
      var self = this;
      var last = null;
      var failKey = null;
      var failMsg = '';

      var chain = jobs.reduce(function (p, job) {
        return p.then(function () { return self.post(job); }).then(function (res) {
          if (res.ok) last = res.data;
          else { failKey = job.key; failMsg = res.message; }
        });
      }, Promise.resolve());

      chain
        .then(function () {
          var sections = last && last.sections;
          if (failKey || !sections || !sections[self.sectionId]) return self.refresh(failKey, failMsg);
          self.apply(sections, {});
        })
        .catch(function () { return self.refresh(null, self.S.error); })
        .then(function () {
          self.busy = false;
          self.classList.remove('is-loading');
          var r = self.root;
          if (r) r.removeAttribute('aria-busy');
          if (self.again || Object.keys(self.queue).length) {
            self.again = false;
            self.flush(force);
            return;
          }
          if (self.afterFlush) { var f = self.afterFlush; self.afterFlush = null; f(); }
        });
    }

    post(job) {
      var sections = this.sectionId + ',cart-icon-bubble';
      return fetch(routesUrl('cart_change_url', '/cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: job.key, quantity: job.qty, sections: sections, sections_url: window.location.pathname })
      }).then(function (r) {
        return r.json().then(function (data) {
          var bad = !r.ok || data.status || data.errors;
          return { ok: !bad, data: data, message: (data && (data.description || data.message)) || '' };
        });
      });
    }

    /* Ricarica lo stato reale del carrello (dopo un errore o tornando indietro) */
    refresh(errorKey, errorMsg) {
      var self = this;
      var base = routesUrl('cart_url', '/cart');
      var sections = {};
      return Promise.all([
        fetch(base + '?section_id=' + encodeURIComponent(this.sectionId)).then(function (r) { return r.text(); }),
        fetch(base + '?section_id=cart-icon-bubble').then(function (r) { return r.text(); }).catch(function () { return ''; })
      ]).then(function (res) {
        sections[self.sectionId] = res[0];
        if (res[1]) sections['cart-icon-bubble'] = res[1];
        self.apply(sections, { errorKey: errorKey, errorMsg: errorMsg || self.S.error });
      });
    }

    /* ---------- Sostituisce il contenuto con quello nuovo ---------- */
    apply(sections, opts) {
      var html = sections[this.sectionId];
      var doc = new DOMParser().parseFromString(html || '', 'text/html');
      var next = doc.querySelector('[data-armonia-cart-root]');
      if (!next) { window.location.reload(); return; }

      var focus = this.captureFocus();
      this.saveCode();
      this.root.replaceWith(next);
      this.updateBubble(sections['cart-icon-bubble']);
      this.afterRender(false);

      var isEmpty = next.dataset.empty === 'true';
      document.querySelectorAll('[data-armonia-cart-related]').forEach(function (el) { el.hidden = isEmpty; });

      if (opts && opts.errorKey) this.showLineError(opts.errorKey, opts.errorMsg);
      this.restoreFocus(focus);
      this.announce(next);
      document.dispatchEvent(new CustomEvent('armonia:favorites-changed'));
      document.dispatchEvent(new CustomEvent('armonia:cart-updated', { detail: { count: parseInt(next.dataset.count, 10) || 0, total: parseInt(next.dataset.total, 10) || 0 } }));
    }

    updateBubble(html) {
      if (!html) return;
      var bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;
      var d = new DOMParser().parseFromString(html, 'text/html');
      var inner = d.querySelector('.shopify-section');
      bubble.innerHTML = inner ? inner.innerHTML : d.body.innerHTML;
    }

    showLineError(key, msg) {
      var lines = this.root.querySelectorAll('[data-armonia-line]');
      for (var i = 0; i < lines.length; i++) {
        if (lines[i].dataset.key === key) {
          var e = lines[i].querySelector('[data-armonia-line-error]');
          if (e) e.textContent = msg || this.S.error;
          return;
        }
      }
      var live = this.live;
      if (live && msg) live.textContent = msg;
    }

    announce(next) {
      if (!this.live) return;
      var S = this.S;
      var count = parseInt(next.dataset.count, 10) || 0;
      var countText = count === 1 ? S.countOne : fmt(S.countMany, { count: count });
      var msg = '';
      if (this.info && this.info.kind === 'removed') msg = fmt(S.removed, { product: this.info.title });
      else if (this.info && this.info.kind === 'moved') msg = fmt(S.moved, { product: this.info.title });
      if (next.dataset.empty !== 'true') {
        msg += ' ' + fmt(S.updated, { count: countText, total: A.formatMoney ? A.formatMoney(parseInt(next.dataset.total, 10) || 0) : '' });
      }
      this.info = null;
      var live = this.live;
      live.textContent = '';
      setTimeout(function () { live.textContent = msg.trim(); }, 60);
    }

    /* ---------- Focus ---------- */
    captureFocus() {
      var a = document.activeElement;
      if (!a || !this.contains(a)) return null;
      var li = a.closest && a.closest('[data-armonia-line]');
      return li ? { key: li.dataset.key, focus: a.getAttribute('data-focus') } : null;
    }

    restoreFocus(f) {
      var root = this.root;
      if (!root) return;
      if (f) {
        var lines = root.querySelectorAll('[data-armonia-line]');
        for (var i = 0; i < lines.length; i++) {
          if (lines[i].dataset.key === f.key) {
            var el = f.focus && lines[i].querySelector('[data-focus="' + f.focus + '"]');
            if (el) el.focus({ preventScroll: true });
            return;
          }
        }
        /* la riga non c'è più: porta il focus sul titolo della pagina */
        var t = root.querySelector('[data-armonia-cart-title]');
        if (t) t.focus({ preventScroll: true });
      }
    }

    /* ---------- Preferiti ---------- */
    moveToFavorites(li) {
      var handle = li.dataset.handle;
      var list = A.storage ? A.storage.get('favorites', []) : [];
      if (!Array.isArray(list)) list = [];
      if (list.indexOf(handle) === -1) {
        list.push(handle);
        if (A.storage) A.storage.set('favorites', list);
        track('add_to_wishlist', { item_handle: handle, source: 'cart' });
      }
      document.dispatchEvent(new CustomEvent('armonia:favorites-changed', { detail: { list: list } }));
      this.info = { kind: 'moved', title: li.dataset.title };
      this.setQty(li, 0, true);
    }

    /* ---------- Codice sconto ---------- */
    saveCode() {
      var root = this.root;
      var input = root && root.querySelector('[data-armonia-code]');
      var d = root && root.querySelector('[data-armonia-discount]');
      if (!input) return;
      this.codeState.value = input.value;
      this.codeState.open = !!(d && d.open);
    }

    restoreCode() {
      var root = this.root;
      var input = root.querySelector('[data-armonia-code]');
      var d = root.querySelector('[data-armonia-discount]');
      if (!input) return;
      input.value = this.codeState.value;
      if (d && this.codeState.open) d.open = true;
      if (this.codeState.ready && input.value.trim()) this.showReady(input.value.trim());
    }

    showReady(code) {
      var msg = this.root.querySelector('.armonia-cart-discount__msg');
      if (!msg) return;
      msg.classList.remove('is-error');
      msg.textContent = fmt(this.S.codeReady, { code: code }) + ' ';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'armonia-cart-discount__clear';
      b.setAttribute('data-armonia-code-clear', '');
      b.textContent = this.S.codeClear;
      msg.appendChild(b);
      this.codeState.ready = true;
    }

    applyCode() {
      var root = this.root;
      var input = root.querySelector('[data-armonia-code]');
      var msg = root.querySelector('.armonia-cart-discount__msg');
      if (!input || !msg) return;
      var v = input.value.trim().toUpperCase();
      if (!v) {
        this.codeState.ready = false;
        msg.classList.add('is-error');
        msg.textContent = this.S.codeEmpty;
        input.focus();
        return;
      }
      input.value = v;
      this.showReady(v);
      track('add_discount_code', { coupon: v, source: 'cart' });
    }

    clearCode() {
      var root = this.root;
      var input = root.querySelector('[data-armonia-code]');
      var msg = root.querySelector('.armonia-cart-discount__msg');
      if (input) { input.value = ''; input.focus(); }
      if (msg) { msg.textContent = ''; msg.classList.remove('is-error'); }
      this.codeState.ready = false;
      this.codeState.value = '';
    }
  }

  if (!customElements.get('armonia-cart')) customElements.define('armonia-cart', ArmoniaCart);
})();
